import React from 'react';

import { ReactComponent as QuestionMarkIcon } from '../../assets/images/questionMark.svg';
import { Content, Icon, TooltipWrapper, Wrapper } from './styled';

type Props = {
  text?: string;
  description?: string | null;
  position?: 'left' | 'right';
  textTestId?: string;
  blackTheme?: boolean;
};

const IconTooltip = ({
  text,
  description,
  position = 'right',
  textTestId = 'tooltip',
  blackTheme,
}: Props): JSX.Element => (
  <Wrapper>
    <span className="tooltipText" data-testid={`${textTestId}Text`}>
      {text}
    </span>
    <TooltipWrapper>
      <Icon data-testid={`${textTestId}Icon`}>
        <QuestionMarkIcon />
      </Icon>
      {description && (
        <Content data-testid={`${textTestId}Description`} $isLeft={position === 'left'} $blackTheme={blackTheme}>
          {description}
        </Content>
      )}
    </TooltipWrapper>
  </Wrapper>
);

export default IconTooltip;
